import { render, staticRenderFns } from "./NationalcardConfirmation.vue?vue&type=template&id=2746a379"
import script from "./NationalcardConfirmation.vue?vue&type=script&lang=js"
export * from "./NationalcardConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports